import { createSelector } from '@opengov/compose-app/reselect';

import { chartSelector } from '../state';

// restricting to keep svg from death
export const MAX_VISUALIZATION_DATA_LENGTH = 10000;

export const getContainerWidth = createSelector(chartSelector, (state) => state.containerWidth);

export const getChartData = createSelector(chartSelector, (state) =>
  state.chartData.slice(0, MAX_VISUALIZATION_DATA_LENGTH)
);

export const getSelectedCategory = createSelector(chartSelector, (state) => state.selectedCategory);

export const getChartContainerRect = createSelector(chartSelector, (state) => state.chartContainerRect);

export const getSelectedElements = createSelector(chartSelector, (state) => state.selectedElements);

export const getTooltip = createSelector(chartSelector, (state) => state.tooltip);

export const getSelectedPoint = createSelector(chartSelector, (state) => state.selectedPoint);

export const selectCategorizedByColumnForChart = createSelector(
  chartSelector,
  (state) => state.reportConfiguration.visualizationQuery.categorizedByColumn
);

export const selectHasVisualizationData = createSelector(
  chartSelector,
  (state) =>
    Boolean(state?.reportConfiguration?.reportId) &&
    state.visualizationResult.data?.length !== 0 &&
    state.visualizationResult.columns?.length !== 0
);

// basically, if we have a report configuration we are good to
// calculate everything
export const selectHaveDataToDisplay = createSelector(
  chartSelector,
  (state) => Boolean(state?.reportConfiguration?.reportId) && state?.chartData?.length !== 0
);
